import React from 'react'

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Helmet } from "react-helmet-async";
const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

const AnimateSection = ({ children }) => {
    const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.15 });
    return (
        <motion.div
            ref={ref}
            variants={fadeUp}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
        >
            {children}
        </motion.div>
    );
};

function About() {
    return (
        <>
          <Helmet>
                <title>
                    About Al Ibtekar | Cable Management & Termination Solutions UAE
                </title>

                <meta
                    name="description"
                    content="Learn about Al Ibtekar, a UAE-based technical partner providing reliable cable management, cable termination, electrical enclosures, labelling and E&I solutions for industrial applications."
                />

                <meta
                    name="keywords"
                    content="about Al Ibtekar, cable management company UAE, cable termination company UAE, cable management solutions UAE, electrical solutions UAE, E&I solutions UAE, electrical enclosures UAE, industrial electrical solutions UAE"
                />

                <link
                    rel="canonical"
                    href="https://saig.me/about"
                />

                <meta
                    property="og:title"
                    content="About Al Ibtekar | Cable Management & Termination Solutions UAE"
                />

                <meta
                    property="og:description"
                    content="Discover Al Ibtekar's journey, mission, vision and technical expertise in cable management, cable termination and industrial electrical solutions."
                />

                <meta
                    property="og:url"
                    content="https://saig.me/about"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:site_name"
                    content="Al Ibtekar"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="About Al Ibtekar | Cable Management & Termination Solutions UAE"
                />

                <meta
                    name="twitter:description"
                    content="Learn about Al Ibtekar and our reliable cable management, cable termination and industrial electrical solutions in the UAE."
                />
            </Helmet>
            <div className='newbanner-about'>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Driven by Innovation. Defined by Trust.</h6>
                    <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Delivering certified, reliable, and field-tested solutions for the electrical and industrial world.
                        From humble beginnings to trusted partnerships — we engineer what the industry needs.
                    </p>
                </div>
            </div>
            {/* <div className="mt-[91px] overflow-hidden relative">
                <img src="/assets/about/bg1.png" className='w-full lg:h-auto h-[300px] object-cover' alt="Dedicated Al Ibtekar team delivering innovative electrical and cable solutions" />
                <div className="absolute lg:top-[125px] top-[20px] max-w-[1440px] w-full mx-auto left-1/2 -translate-x-1/2 lg:px-[50px] px-[20px]">
                    <h6 className="font-[500] font-kanit lg:text-[70px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Driven by Innovation. Defined by Trust.</h6>
                    <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Delivering certified, reliable, and field-tested solutions for the electrical and industrial world.
                        From humble beginnings to trusted partnerships — we engineer what the industry needs.
                    </p>
                </div>
                <h1 className='absolute font-[600] font-kanit lg:text-[180px] text-[60px] lg:leading-[180px] leading-[70px] text-[#FFFFFF4F] right-[0px] lg:bottom-[86px] bottom-[40px]'>About</h1>
            </div> */}
            <section className='pt-[30px] lg:pb-[30px] pb-[30px]'>
                <AnimateSection>
                    <div className="flex lg:flex-row max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] flex-col lg:gap-[120px] gap-[50px] justify-between items-center">
                        <div>
                            <img style={{ width: '600px', height: '600px', objectFit: 'cover', borderRadius: '20px' }} src="/assets/team.jpeg" alt="Dedicated Al Ibtekar team delivering innovative electrical and cable solutions" />
                        </div>
                        <div>
                            <p className="font-[400] font-kanit text-[14px] leading-[20px] uppercase tracking-[2px] text-[#FBB210] pb-[15px]">ABOUT US</p>
                            <h6 className="font-[500] font-kanit lg:text-[42px] text-[26px] lg:leading-[50px] leading-[34px] tracking-[0.2px] text-[#0F0F0F] max-w-[424px] w-full pb-[20px]">Who We Are</h6>
                            <p className="max-w-[605px] w-full font-[300] font-kanit text-[17px] leading-[27px] text-[#616161] pb-[40px]">
                                Founded in September 2018, Al Ibtekar began as a small yet focused two-member team with a bold mission — to add real value to the cable management and termination industry.

                                Our approach has always been rooted in the field — we listen to the problems faced by technicians, engineers, and site professionals, and turn those insights into practical, reliable, and certified solutions. By aligning with niche, innovation-driven manufacturers, we deliver products that are built not just for today’s standards, but for tomorrow’s challenges.

                                Over the years, we've grown into a trusted technical partner for commercial, industrial, and process applications — offering custom-built enclosures, advanced labeling systems, integration services, and more.

                                With every solution we offer, we uphold our commitment to quality, consistency, technical excellence, and customer satisfaction.
                            </p>
                        </div>
                    </div>
                </AnimateSection>
            </section>
            <section className='service-section lg:pt-[50px] pt-[60px] lg:pb-[50px] pb-[60px]'>
                <AnimateSection>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                  <p className="font-[400] text-left font-kanit text-[14px] leading-[20px] uppercase tracking-[2px] text-[#FBB210] pb-[3px]">
    Mission & Vision
</p>
<h6 className="font-[500] text-left font-kanit lg:text-[42px] text-[26px] lg:leading-[50px] leading-[34px] tracking-[0.2px] text-[#0F0F0F] lg:pb-[80px] pb-[40px]">
    Our Mission & Vision
</h6>
                </div>

                    <div className="lg:px-[50px] max-w-[1440px] w-full mx-auto px-[20px] grid lg:grid-cols-2 grid-cols-1 gap-[24px] overflow-hidden">
                        <div className='bg-[#FFFFFF] rounded-[20px] p-[30px] hover:bg-[#FBB210] transition-colors duration-300 text-[#000000] hover:text-[#fff]'>
                            <img src="/assets/about/icon1.svg" alt="Dedicated Al Ibtekar team delivering innovative electrical and cable solutions" />
                            <h6 className="pt-[8px] pb-[18px] font-[500] font-kanit text-[22px] leading-[33px] tracking-[0.3px]">Vision</h6>
                            <p className="font-[300] font-kanit text-[17px] leading-[27px] ">
                                To become a one-stop technical destination where trusted, tailored solutions await every customer — backed by innovation, precision, and long-term reliability.
                            </p>
                        </div>

                        <div className='bg-[#FFFFFF] rounded-[20px] p-[30px] hover:bg-[#FBB210] transition-colors duration-300 text-[#000000] hover:text-[#fff]'>
                            <img src="/assets/about/icon2.svg" alt="Dedicated Al Ibtekar team delivering innovative electrical and cable solutions" />
                            <h6 className="pt-[8px] pb-[18px] font-[500] font-kanit text-[22px] leading-[33px] tracking-[0.3px] ">Mission</h6>
                            <p className="font-[300] font-kanit text-[17px] leading-[27px] ">
                                To continuously add value to the cable management and termination industry by understanding real-world challenges, creating smart solutions, and connecting customer needs with innovative, high-quality products.

                                We aim to bridge the gap between rapidly evolving technical requirements and field-ready solutions, ensuring performance, safety, and satisfaction every step of the way.
                            </p>
                        </div>

                        {/* <div className='bg-[#FFFFFF] rounded-[20px] p-[20px] flex lg:flex-row flex-col items-center gap-[26px]'>
                            <img src="/assets/about/img5.png" alt="Dedicated Al Ibtekar team delivering innovative electrical and cable solutions" />
                            <p className="font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A]">Our team of creative tech enthusiasts works with a single-minded focus of crafting verified, customized solutions that perfectly fit the needs and requirements of our client.</p>
                        </div>
                        <div className='bg-[#FFFFFF] rounded-[20px] p-[20px] flex lg:flex-row flex-col items-center gap-[26px]'>
                            <img src="/assets/about/img3.png" alt="Dedicated Al Ibtekar team delivering innovative electrical and cable solutions" />
                            <p className="font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A]">To align our processes with this approach of partnership, we inculcate a sense of ownership in our team members. They operate as an integral part of your success roadmap.</p>
                        </div>
                        <div className='bg-[#FFFFFF] rounded-[20px] p-[20px] flex lg:flex-row flex-col items-center gap-[26px]'>
                            <img src="/assets/about/img4.png" alt="Dedicated Al Ibtekar team delivering innovative electrical and cable solutions" />
                            <p className="font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A]">We don’t view ourselves as a third-party service provider but as a partner in your journey toward digital transformation.</p>
                        </div>
                        <div className='bg-[#FFFFFF] rounded-[20px] p-[20px] flex lg:flex-row flex-col items-center gap-[26px]'>
                            <img src="/assets/about/img6.png" alt="Dedicated Al Ibtekar team delivering innovative electrical and cable solutions" />
                            <p className="font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A]">We leverage a mix of skilled experts, global benchmarks and deep functional insights to deliver on our promise of efficient and quick outcomes.</p>
                        </div> */}
                    </div>
                </AnimateSection>
            </section>
            <section className='lg:pt-[60px] pt-[60px] pb-[60px] relative overflow-hidden' style={{ background: `radial-gradient(104.59% 215.16% at 95% 10%, rgba(228, 74, 26, 0.16) 0%, rgba(228, 74, 26, 0) 29%), radial-gradient(104.59% 215.16% at 5% 90%, rgba(255, 27, 153, 0.15) 0%, rgba(255, 27, 153, 0) 25%)` }}>
                <AnimateSection>
                    <div className="absolute top-[60px] left-[50px]">
                        <img src="/assets/home/wrap2.svg" alt="Dedicated Al Ibtekar team delivering innovative electrical and cable solutions" />
                    </div>
                    <div className='relative max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>
                        <p className="font-[400] font-kanit text-left text-[14px] leading-[20px] uppercase tracking-[2px] text-[#FBB210] pb-[15px]">Our Values</p>
                        <h6 className="font-[500] font-inter text-left lg:text-[42px] text-[26px] lg:leading-[50px] leading-[34px] tracking-[0.2px] text-[#0F0F0F] lg:pb-[130px] pb-[30px]">Guided by Principles, Driven by Purpose.</h6>
                    </div>
                    <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>
                        <div className='border-t-[2px] lg:border-[#49577A66] border-transparent flex flex-wrap lg:gap-[30px] gap-0 lg:justify-center'>
                            <div className='lg:pt-[40px] pt-[20px]'>
                                <img src="/assets/value/item1.svg" className='h-[40px] object-cover' alt="Dedicated Al Ibtekar team delivering innovative electrical and cable solutions" />
                                <h6 className="pt-[30px] pb-[10px] font-[500] font-kanit text-[22px] leading-[33px] tracking-[0.3px] text-[#0F0F0F]">Quality</h6>
                                <p className="max-w-[260px] w-full font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A] pb-[22px]">We deliver only reliable, high-performance solutions that meet industry standards.</p>
                            </div>
                            <div className="line1"></div>
                            <div className='lg:pt-[40px] pt-[20px]'>
                                <img src="/assets/value/item2.svg" className='h-[40px] object-cover' alt="Dedicated Al Ibtekar team delivering innovative electrical and cable solutions" />
                                <h6 className="pt-[30px] pb-[10px] font-[500] font-kanit text-[22px] leading-[33px] tracking-[0.3px] text-[#0F0F0F]">Technical Excellence</h6>
                                <p className="max-w-[260px] w-full font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A] pb-[22px]">Backed by real-world expertise, our solutions are built with precision and purpose.</p>
                            </div>
                            <div className="line2"></div>
                            <div className='lg:pt-[40px] pt-[20px]'>
                                <img src="/assets/value/item3.svg" className='h-[40px] object-cover' alt="Dedicated Al Ibtekar team delivering innovative electrical and cable solutions" />
                                <h6 className="pt-[30px] pb-[10px] font-[500] font-kanit text-[22px] leading-[33px] tracking-[0.3px] text-[#0F0F0F]"> Customer Commitment</h6>
                                <p className="max-w-[260px] w-full font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A] pb-[22px]">We prioritize client satisfaction with responsive service and tailored support.</p>
                            </div>
                            <div className="line3"></div>
                            <div className='lg:pt-[40px] pt-[20px]'>
                                <img src="/assets/value/item4.svg" className='h-[40px] object-cover' alt="Dedicated Al Ibtekar team delivering innovative electrical and cable solutions" />
                                <h6 className="pt-[30px] pb-[10px] font-[500] font-kanit text-[22px] leading-[33px] tracking-[0.3px] text-[#0F0F0F]">Integrity</h6>
                                <p className="max-w-[260px] w-full font-[300] font-kanit text-[17px] leading-[27px] text-[#49577A] pb-[22px]">We operate with honesty, transparency, and a strong sense of responsibility.</p>
                            </div>
                        </div>
                    </div>
                </AnimateSection>
            </section>
            <section className='lg:pt-[60px] pt-[60px] lg:pb-[60px] pb-[60px] overflow-hidden'>
                <AnimateSection>
                    <h6 className='font-[500] font-kanit lg:text-[42px] text-[26px] lg:leading-[50px] leading-[40px] tracking-[0.2px] text-[#000000] text-center pb-[70px]'>What Sets Us Apart</h6>
                    <div className="part-bg max-w-[946px] mx-auto w-full grid lg:grid-cols-3 grid-cols-1 items-end">
                        <div className='set-card flex flex-col px-[22px] py-[40px] hover:py-[22px] items-center '>
                            <img
                                src="/assets/about/icon1.svg"
                                alt="Icon"
                                className="set-img mb-[10px] transition-all duration-300"
                            />
                            <div className="flex items-center gap-[34px]">
                                <h6 className="font-[500] font-kanit text-[22px] leading-[33px] text-[#FFFFFF] tracking-[0.3px]">
                                    Our Approach
                                </h6>
                                <img src="/assets/value/right-arrow.svg" alt="Dedicated Al Ibtekar team delivering innovative electrical and cable solutions" />
                            </div>
                            <p className="set-text font-[300] font-kanit pt-[10px] text-[17px] leading-[27px] text-center text-[#FFFFFF] transition-all duration-300">
                                We focus on real-world problems, working closely with the field and manufacturers to deliver practical, high-performance solutions.
                            </p>
                        </div>
                        <div className='set-card bg-[#01386A] hover:bg-[#FBB210] flex flex-col px-[22px] py-[40px] hover:py-[22px] items-center transition-all duration-300 ease-in-out'>
                            <img
                                src="/assets/about/icon1.svg"
                                alt="Icon"
                                className="set-img mb-[10px] transition-all duration-300"
                            />
                            <div className="flex items-center gap-[34px]">
                                <h6 className="font-[500] font-kanit text-[22px] leading-[33px] text-[#FFFFFF] tracking-[0.3px]">
                                    Our Team of Experts
                                </h6>
                                <img src="/assets/value/right-arrow.svg" alt="Dedicated Al Ibtekar team delivering innovative electrical and cable solutions" />
                            </div>
                            <p className="set-text font-[300] font-kanit pt-[10px] text-[17px] leading-[27px] text-center text-[#FFFFFF] transition-all duration-300">
                                Our skilled team brings deep industry knowledge and hands-on experience to ensure every solution is precise, reliable, and field-ready.
                            </p>
                        </div>
                        <div className='set-card bg-[#01386A] hover:bg-[#FBB210] flex flex-col px-[22px] py-[40px] hover:py-[22px] items-center transition-all duration-300 ease-in-out'>
                            <img
                                src="/assets/about/icon1.svg"
                                alt="Icon"
                                className="set-img mb-[10px] transition-all duration-300"
                            />
                            <div className="flex items-center gap-[34px]">
                                <h6 className="font-[500] font-kanit text-[22px] leading-[33px] text-[#FFFFFF] tracking-[0.3px]">
                                    Our Experience
                                </h6>
                                <img src="/assets/value/right-arrow.svg" alt="Dedicated Al Ibtekar team delivering innovative electrical and cable solutions" />
                            </div>
                            <p className="set-text font-[300] font-kanit pt-[10px] text-[17px] leading-[27px] text-center text-[#FFFFFF] transition-all duration-300">
                                With 6+ years in the industry, we’ve earned trust by delivering consistent, certified solutions across commercial and industrial sectors.
                            </p>
                        </div>

                    </div>
                </AnimateSection>
            </section>
        </>
    )
}


export default About
